import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { GetPresignedDownloadURLForBulkSpocTemplateRPC } from "./getPresignedDownloadUrlForBulkSpocTemplateRPC";

export class GetPresignedDownloadURLForBulkSpocTemplateRPCClientImpl extends GetPresignedDownloadURLForBulkSpocTemplateRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: GetPresignedDownloadURLForBulkSpocTemplateRPC.Request): Promise<LeoRPCResult<GetPresignedDownloadURLForBulkSpocTemplateRPC.Response, GetPresignedDownloadURLForBulkSpocTemplateRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/GetPresignedDownloadURLForBulkSpocTemplate",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      GetPresignedDownloadURLForBulkSpocTemplateRPC.ResponseDTO,
      GetPresignedDownloadURLForBulkSpocTemplateRPC.Errors.ErrorsDTO,
      GetPresignedDownloadURLForBulkSpocTemplateRPC.Response,
      GetPresignedDownloadURLForBulkSpocTemplateRPC.Errors.Errors
    >(
      response,
      "spoc-management/GetPresignedDownloadURLForBulkSpocTemplate",
      GetPresignedDownloadURLForBulkSpocTemplateRPC.Response.fromDTO,
      GetPresignedDownloadURLForBulkSpocTemplateRPC.Errors.fromDTO
    );
  }
}
